(function () {
  function updateVisiblePrices(currency: string) {
    document.querySelectorAll('.price').forEach((el) => (el as HTMLElement).classList.add('d-none'));
    document.querySelectorAll('.price-' + currency).forEach((el) => (el as HTMLElement).classList.remove('d-none'));

    document.querySelectorAll('.price-btn').forEach((el) => (el as HTMLElement).classList.add('d-none'));
    document.querySelectorAll('.price-btn-' + currency).forEach((el) => (el as HTMLElement).classList.remove('d-none'));
  }

  function attachSelectLogic(wrapper: HTMLElement, originalSelect?: HTMLSelectElement) {
    if (wrapper.dataset.logicInitialized === 'true') return;
    const trigger = wrapper.querySelector('.custom-select-trigger') as HTMLElement;
    const options = wrapper.querySelectorAll('.custom-option');
    const isCurrency = wrapper.classList.contains('currency-switcher');

    if (!trigger) return;

    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      const isOpen = wrapper.classList.contains('open');

      document.querySelectorAll('.custom-select-wrapper.open').forEach(w => {
        if (w !== wrapper) {
          w.classList.remove('open');
          w.querySelector('.custom-select-trigger')?.setAttribute('aria-expanded', 'false');
        }
      });

      wrapper.classList.toggle('open');
      trigger.setAttribute('aria-expanded', (!isOpen).toString());
    });

    options.forEach(opt => {
      opt.addEventListener('click', (e) => {
        e.stopPropagation();
        const val = opt.getAttribute('data-value') || '';
        const text = opt.textContent || '';
        wrapper.querySelectorAll('.custom-option').forEach(o => o.classList.remove('selected'));
        opt.classList.add('selected');

        wrapper.classList.remove('is-placeholder');

        if (isCurrency) {
          localStorage.setItem('currency', val);
          updateVisiblePrices(val);
          document.querySelectorAll('.currency-switcher .current-value').forEach(el => el.textContent = text);

          document.querySelectorAll(`.currency-switcher .custom-option[data-value="${val}"]`).forEach(o => {
            o.parentElement?.querySelectorAll('.custom-option').forEach(other => other.classList.remove('selected'));
            o.classList.add('selected');
          });
        } else if (originalSelect) {
          originalSelect.value = val;
          originalSelect.dispatchEvent(new Event('change', { bubbles: true }));
          const display = wrapper.querySelector('.current-value');
          if (display) display.textContent = text;
        }

        wrapper.classList.remove('open');
        trigger.setAttribute('aria-expanded', 'false');
      });
    });

    wrapper.dataset.logicInitialized = 'true';
  }

  function wrapWpcf7Select(select: HTMLSelectElement) {
    if (select.dataset.customInitialized === 'true' || select.closest('.custom-select-wrapper')) return;

    const wrapper = document.createElement('div');
    wrapper.className = 'custom-select-wrapper wpcf7-custom-style';

    if (select.value === '') {
      wrapper.classList.add('is-placeholder');
    }

    const optionsHtml = Array.from(select.options)
      .filter(opt => opt.value !== '')
      .map(opt =>
        `<div class="custom-option ${opt.selected ? 'selected' : ''}" data-value="${opt.value}">${opt.textContent}</div>`
      ).join('');

    wrapper.innerHTML = `
      <div class="custom-select-trigger" role="button" tabindex="0" aria-expanded="false">
        <span class="current-value">${select.options[select.selectedIndex]?.textContent || ''}</span>
        <div class="arrow"></div>
      </div>
      <div class="custom-options">${optionsHtml}</div>
    `;

    select.style.display = 'none';
    select.insertAdjacentElement('afterend', wrapper);
    select.dataset.customInitialized = 'true';

    attachSelectLogic(wrapper, select);
  }

  const scan = () => {
    document.querySelectorAll('.wpcf7-select').forEach(el => wrapWpcf7Select(el as HTMLSelectElement));
    document.querySelectorAll('.custom-select-wrapper.currency-switcher').forEach(el => attachSelectLogic(el as HTMLElement));
  };

  const observer = new MutationObserver(scan);
  observer.observe(document.body, { childList: true, subtree: true });
  scan();

  const savedCurrency = localStorage.getItem('currency') || 'euro';
  updateVisiblePrices(savedCurrency);

  const savedLabel = document.querySelector(
    `.currency-switcher .custom-option[data-value="${savedCurrency}"]`
  )?.textContent;
  if (savedLabel) {
    document.querySelectorAll('.currency-switcher .current-value').forEach(el => el.textContent = savedLabel);
  }

  window.addEventListener('click', () => {
    document.querySelectorAll('.custom-select-wrapper.open').forEach(w => {
      w.classList.remove('open');
      w.querySelector('.custom-select-trigger')?.setAttribute('aria-expanded', 'false');
    });
  });
})();